import { render, staticRenderFns } from "./NovelDetailPage.vue?vue&type=template&id=4f984b95"
import script from "./NovelDetailPage.vue?vue&type=script&lang=ts"
export * from "./NovelDetailPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f984b95')) {
      api.createRecord('4f984b95', component.options)
    } else {
      api.reload('4f984b95', component.options)
    }
    module.hot.accept("./NovelDetailPage.vue?vue&type=template&id=4f984b95", function () {
      api.rerender('4f984b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/NovelDetailPage.vue"
export default component.exports